export default __webpack_public_path__ + "static/media/attribute_Unlocked.f8f940b1.png";